"use client";

import React from "react";
import QuickContact from "@/components/common/QuickContact";
import AboutBannerDesktop from "@/components/pageComponent/about-us/Desktopbanner";
import TalentSetDesktop from "@/components/pageComponent/about-us/setUpDesktop";
import HeroValuesDesktop from "@/components/pageComponent/about-us/heroValuesDesktop";
import AboutMilesEducationDesktop from "@/components/pageComponent/about-us/milesAboutDesktop";
import MilesRevolutionDesktop from "@/components/pageComponent/about-us/milesRevoDesktop";
import StatsMilesDesktop from "@/components/pageComponent/about-us/statMilesDesktop";
import TeamSectionDesktop from "@/components/pageComponent/about-us/milesTeamDesktop";
import EventTicker from "@/components/common/EventTicker";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const DesktopPage: React.FC = () => {
  return (
    <main className=" bg-white w-full">
      <div className="w-full">
        <EventTicker />
      </div>
      <GlobalHeaderNew />
      <AboutBannerDesktop />
      <TalentSetDesktop />
      <HeroValuesDesktop />
      <AboutMilesEducationDesktop />
      <MilesRevolutionDesktop />
      <div className="md:flex md:flex-col md:items-center w-full h-auto xl:px-0 md:px-6 lg:!px-6  px-5 relative square_grid_bg">
        <StatsMilesDesktop />
      </div>
      <TeamSectionDesktop />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <QuickContact />
    </main>
  );
};

export default DesktopPage;
